<template>
  <div>
    <div class="bannerContent">
      <div class="bannerBox">
        <el-row>
          <el-col :span="5"
            ><div class="grid-content purple" @click="$router.push('/Home/pages')">天府再生资源云平台</div></el-col
          >
          <el-col :span="19"
            ><div class="grid-content routePurple">
            <span style="font-size: 20px" :key="index" :class="['tab', choseBannerPath == item.path?'choseBanner':'']" v-for="(item,index) in pathArr" @click="chosePath(item.path)">{{item.name}}</span>
          </div></el-col
          >
        </el-row>
      </div>
    </div>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
import { logoutPlatform } from '@/API/login/login';
export default {
  name: 'index',
  data() {
    return {
      registerVisible: false,
      pathArr: [
        {
          name: '碳足迹管理',
          path: '/secondaryHomepage/carbonFootprint',
        },
        {
          name: '溯源监管',
          path: '/secondaryHomepage/traceabilitySupervision',
        },
        {
          name: '供应链金融',
          path: '/secondaryHomepage/supplyChain',
        },
        {
          name: '产业链大数据',
          path: '/secondaryHomepage/industrialChain',
        },
        {
          name: '市场风控',
          path: '/secondaryHomepage/marketRiskControl',
        },
        {
          name: '供需信息',
          path: '/secondaryHomepage/supplyDemand',
        },
        {
          name: '交易撮合',
          path: '/secondaryHomepage/transactionMatching',
        },
      ],
      choseBannerPath:'/secondaryHomepage/carbonFootprint',
      userInfo:localStorage.getItem('ordinaryUser') ? JSON.parse(localStorage.getItem('ordinaryUser')) : null
    };
  },
  watch:{
    $route(to, from) {
      console.log('路由变化：', from.path, '→', to.path);
      this.choseBannerPath = to.path.match(/^(\/[^/]+\/[^/]+)/)[0];
    },
  },
  created() {},
  mounted() {
    this.choseBannerPath = this.$route.path
  },
  methods: {
    chosePath(path){
      this.choseBannerPath = path
      this.$router.push(path)
    }
  },
};
</script>

<style lang="less" scoped>
.bannerContent {
  height: 90px;
  display: flex;
  background: url("~@/assets/recycling/index/headerBGlogo.png") no-repeat center;
  background-size: cover;
  justify-content: center;
  .bannerBox {
    width: 1400px;
    height: 90px;
    line-height: 90px;
    .purple {
      font-size: 30px;
      font-weight: 700;
      letter-spacing: 1px;
      color: #038F3B;
      cursor: pointer;
    }
  }
}
.routePurple {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 90px ;
  span{
    cursor: pointer;
    display: flex;
    padding: 10px 20px;
  }
}
.choseBanner {
  color: rgba(0, 0, 0, 1);
  font-weight: 700;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .bannerContent {
    height: 50px;
    margin-bottom: 56px;
    .bannerBox {
      width: 100%;
      .el-row {
        display: flex;
        flex-direction: column;
        .el-col {
          height: 50px;
          line-height: 50px;
          width: 100% !important;
          overflow: auto;
          padding: 0 16px;
        }
      }
    }
    ::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }
  .purple {
    font-size: 20px !important;
  }
  .routePurple {
    align-items: normal;
    display: -webkit-box;
    height: auto;
    width: auto;
    .tab {
      display: inline-block;
      font-size: 14px !important;
      padding: 0;
      width: auto;
      margin-right: 20px;
      float: left;
    }
  }
}
</style>
